import React, { useState } from 'react';
import { Printer, X } from 'lucide-react';

interface PrintDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (options: { showCover: boolean }) => void;
  isEnglish: boolean;
}

export const PrintDialog: React.FC<PrintDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isEnglish,
}) => {
  const [showCover, setShowCover] = useState(true);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 print:hidden">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-sm">
        <div className="flex items-center justify-between p-4 border-b">
          <h3 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
            <Printer className="w-5 h-5" />
            {isEnglish ? 'Print Options' : 'Opções de Impressão'}
          </h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-500"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
        
        <div className="p-4">
          <label className="flex items-center space-x-3">
            <input
              type="checkbox"
              checked={showCover}
              onChange={(e) => setShowCover(e.target.checked)}
              className="rounded border-gray-300 text-blue-600 focus:ring-blue-500 h-4 w-4"
            />
            <span className="text-gray-700">
              {isEnglish ? 'Include cover page' : 'Incluir página de capa'}
            </span>
          </label>
          
          <div className="mt-6 flex justify-end space-x-3">
            <button
              onClick={onClose}
              className="px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-md text-sm"
            >
              {isEnglish ? 'Cancel' : 'Cancelar'}
            </button>
            <button
              onClick={() => onConfirm({ showCover })}
              className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 text-sm"
            >
              {isEnglish ? 'Print' : 'Imprimir'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};